export default __webpack_public_path__ + "static/media/640_business06-es-mobile.21a5863d.png";